const styles = {
  cashbox: {
    width: 80,
    height: 36
  }
}

export default styles
